// Spodní mobilní navigace (bottomNav.js).
export default {
  /** aria-label lišty */
  nav: 'Hlavní navigace',
  home: 'Domů',
  cats: 'Kategorie',
  /** Stav objednávky (page('orderStatus')) */
  orders: 'Objednávky',
  account: 'Účet',
  cart: 'Košík',
  /** položka chatu SupportBoxu (místo Domů, jen se zapnutým chatem) */
  chat: 'Chat',
};
